import ClientTaskDetailPage from './ClientTaskDetailPage';

export default ClientTaskDetailPage;